import { SearchLocationsModelBase } from "./SearchLocationsModel.base"


/* A graphql query fragment builders for SearchLocationsModel */
export { selectFromSearchLocations, searchLocationsModelPrimitives, SearchLocationsModelSelector } from "./SearchLocationsModel.base"

/**
 * SearchLocationsModel
 *
 * Search locations results
 */
export const SearchLocationsModel = SearchLocationsModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self))
    }
  }))
